export const PERSONAL_MORTGAGE = 'cefd18ad-5b13-4aa5-9b16-bf8004594214';
export const PERSONAL_REMORTGAGE = 'ca3ecabe-baa9-4c30-81f5-46754bac1f55';
export const PERSONAL_NEWMORTGAGE = '0c1762d8-c3ae-4664-ad39-4910de583d30';

export const PERSONAL_LOANS = '02823ac7-57cc-4e9e-884a-456bf9fc8ee2';
export const PERSONAL_VEHICLE_FINANCE = 'fea1bc2a-f8d5-4b58-89dc-c508bfe953ab';
export const PERSONAL_CREDIT_CARD = 'aa8323e5-c3c3-4161-b7ae-cee84b74fb75';
export const PERSONAL_INVEST = '13c27bd0-0467-4589-af03-4ddfef093793';
export const PERSONAL_FINANCIAL_PROFILE = '31c44f23-e279-4bf6-ba8d-bfdb72d949fc';
